import React from 'react';
import type { ClassValue } from 'clsx';
import classNames from 'clsx';
import menuItemClasses from '../MenuContent/MenuItem/style/MenuItem.module.scss';
import {
  MenuOrientation,
  selectors,
  type MenuOrientationType,
} from '../../constants';
import { MenuItemContext } from '../../contexts/MenuItemContext';
import { DropdownWrapper } from './DropdownWrapper';
import dropdownClasses from './MegaMenuDropdown.module.scss';
import Submenu from '../Submenu/Submenu';
import type { DropdownProps } from '../../Menu.types';
import classes from './Dropdown.module.scss';

export const Dropdown = React.forwardRef<HTMLDivElement | null, DropdownProps>(
  (
    {
      item,
      currentItem,
      isOpen,
      menuOrientation,
      dropdownAnimationState,
      onEscKeyDown,
      direction,
      onItemClick,
      className,
      elementProps,
    },
    ref,
  ) => {
    const rootClassNames: Record<MenuOrientationType, Array<ClassValue>> = {
      [MenuOrientation.Horizontal]: [
        menuItemClasses.horizontalDropdownDisplayWrapper,
      ],
      [MenuOrientation.Vertical]: [
        menuItemClasses.verticalDropdownDisplayWrapper,
        isOpen && menuItemClasses.expandedDropdown,
      ],
    };

    const displayContainer =
      menuOrientation === 'horizontal' && item.isContainerItem;

    return (
      <div
        className={classNames(
          selectors.dropdown,
          classes.dropdown,
          ...rootClassNames[menuOrientation],
          className,
        )}
        dir={direction}
        ref={ref}
      >
        <MenuItemContext.Provider
          value={{
            item,
            currentItem,
            dropdownAnimationState,
            onEscKeyDown,
          }}
        >
          <DropdownWrapper
            id={`${item.id}-dropdown`}
            menuOrientation={menuOrientation}
            childrenWrapperClassName={classNames(
              dropdownClasses.childrenWrapper,
              classes.dropdownContentWrapper,
            )}
          >
            {item.items && (
              <Submenu
                id={`${item.id}-submenu`}
                className={classNames(classes.submenu, 'submenu')}
                onItemClick={onItemClick}
                dropdownItemClassName={elementProps?.item?.className}
                dropdownSubItemClassName={elementProps?.subItem?.className}
              />
            )}
            {displayContainer && (
              <div className={classes.container}>{item.container}</div>
            )}
          </DropdownWrapper>
        </MenuItemContext.Provider>
      </div>
    );
  },
);
